import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import "./AmpDropdown.css";



export interface Option {
    value: string | number | readonly string[] | undefined | null, 
    text: string,
    displayName?: string 
    disabled?: boolean, 
    subOptions?: Array<Option>
}

export interface AmpDropdownProps {
    onChange?: React.ChangeEventHandler;
    className?: string;
    options: Array<Option | null>;
    value?: string;
    label?: string;
    title?: string;
    id?: string;
    name?: string;
    errorMessage?: string;
    testid?: string;
    ariaLabel?: string;
}

export default function AmpDropdown(props: AmpDropdownProps): JSX.Element {

    const { onChange, className, options, value, label, id, name, errorMessage, testid, title, ariaLabel } = props

    return (
        <>
            {label && <h5 id={id && id + "AmpDropdownTitle"} className="amp-dropdown-title">{label}</h5>}
            <select name={name} id={id} className={className} 
            value={value} title={title} aria-label={ariaLabel && ariaLabel}
            onChange={(e) => onChange && onChange(e)} data-testid={testid ?? "dropdown-test"}>
                {options.map((option, index) => {
                    if(option){
                        if (option.subOptions?.length) {
                            return <optgroup key={index} label={option.text}>
                                {option.subOptions.map((subOption, subIndex) => {
                                    return <option key={`${index}${subIndex}`} value={subOption.value}>{subOption.text}</option>
                                })}
                            </optgroup>
                        } else {
                            return <option key={index} value={option.value} disabled={option.disabled}>{option.text}</option>
                        }
                    } else {
                        return <></>
                    }
                })}
            </select>
            {props.errorMessage ? <div className="input-error-message"><FontAwesomeIcon className="red-cross" icon={faCircleXmark}/> {errorMessage}</div> : ""}
        </>
    )
}